import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IValidateParticipant } from '../../interfaces/send-payment/validate-participant.interface';

export abstract class AbstractRespondentService extends ITableService {
  abstract validateRtn(routingNumber: string): Promise<IValidateParticipant | undefined>;
}
